import styled from "styled-components";

const Heading = styled.h2`
  font-family: Dosis;
  font-style: normal;
  font-weight: bold;
  font-size: 38px;
  line-height: 48px;
  text-align: center;

  color: #0e3d71;
`;

const Text = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 28px;
`;

const BulletPont = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  padding: 0;
  margin: 0;
`;

export { Heading, Text, BulletPont };
